if (document.getElementsByClassName('paragraph--type--accueil-compteur').length > 0) {

    let counters = document.querySelectorAll('.count-number');
    let maxDuration = 3000; // 3 seconds in milliseconds

    counters.forEach((counter) => {
        counter.setAttribute('data-limit', parseInt(counter.innerText));
    });

    function updateCounter(element, count, limit, step, interval) {
        element.innerText = count;

        if (count < limit) {
            setTimeout(() => updateCounter(element, Math.min(count + step, limit), limit, step, interval), interval);
        }
    }

    function startCounter(element, maxDuration) {
        const limit = parseInt(element.getAttribute('data-limit'));
        const step = Math.ceil(limit / (maxDuration / 10)); // Calculate the step size
        const interval = maxDuration / (limit / step); // Calculate the interval based on the step size

        updateCounter(element, 0, limit, step, interval);
    }

    // Function to start the automatic increment for all elements at the same time
    function startAllCounters(elements, maxDuration) {
        elements.forEach((element) => {
            startCounter(element, maxDuration);
        });
    }

    function setupObserver() {
        const observer = new IntersectionObserver((entries) => {
            if (entries.some(entry => entry.isIntersecting)) {
                startAllCounters(counters, maxDuration);
                observer.disconnect();
            }
        }, { threshold: 0.5 });

        counters.forEach((target) => observer.observe(target));
    }

    window.onload = setupObserver;
}